import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { OFFICIAL_LISTING_URL, ZILLOW_LISTING_URL } from '../data/contact';
import { trackEvent } from '../utils/analytics';
import { Reveal } from './Reveal';
export function ListingLinksSection() {
  const {
    t
  } = useLanguage();
  return <section className="w-full border-y border-soft-gray bg-white py-14" data-id="element-366" data-mp="2sftlnfpnd2zh">
      <div className="mx-auto flex max-w-editorial flex-col gap-6 px-5 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-367" data-mp="2of9nq9x91vca">
        <Reveal data-id="element-368" data-mp="2jloko3gsub68">
          <p className="label-caps text-gold" data-id="element-369" data-mp="2eooelsjy98f4">
            {t('Verified Listing Sources', 'Fuentes Oficiales de la Publicación')}
          </p>
          <p className="mt-3 max-w-xl text-[14px] leading-relaxed text-ink/75" data-id="element-370" data-mp="29qmvx8qfrb46">
            {t('Review the property on the official brokerage listing for the most current details.', 'Consulta la publicación oficial de la brokerage para obtener los detalles más actuales.')}
          </p>
        </Reveal>

        <Reveal delay={0.05} data-id="element-371" data-mp="khapd0q0zyj4">
          <div className="flex flex-col gap-3 sm:flex-row" data-id="element-372" data-mp="pacbntskb0cq">
            <a href={OFFICIAL_LISTING_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('official_listing_click', {
            location: 'listing_links'
          })} className="inline-flex items-center justify-center gap-2 bg-midnight px-6 py-4 font-display text-[12px] font-medium uppercase tracking-[0.16em] text-white transition-colors duration-150 ease-out hover:bg-navy" data-id="element-373" data-mp="pbx15500rt3q">
              {t('View Official Brokerage Listing', 'Ver Publicación Oficial')}
              <ExternalLinkIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-374" data-mp="y9qxgfxsamqw" />
            </a>
            <a href={ZILLOW_LISTING_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('zillow_listing_click', {
            location: 'listing_links'
          })} className="inline-flex items-center justify-center gap-2 border border-midnight/25 px-6 py-4 font-display text-[12px] font-medium uppercase tracking-[0.16em] text-midnight transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-375" data-mp="3eymodzl1otqp">
              {t('View on Zillow', 'Ver en Zillow')}
              <ExternalLinkIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-376" data-mp="1asuqbrnqk8qz" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}